import store from "@/store";

export const authenticationRequired = (to: any, from: any, next: any) => {
  if (store.state.user != null && store.state.token != null) {
    if(to.path.startsWith("/panel/")){
      //@ts-ignore
      store.state.menu = 2
    }else if(to.path.startsWith("/panel-facto/")){
      //@ts-ignore
      store.state.menu = 3
    }

    if(store.state.mfa == 0){
      if(to.path === '/tokenValidation'){
        next('/panel-facto/estadisticas');
      }
      else{
        if(to.meta && to.meta.requireUserValid && !store.getters.canNavigate()){
          next('/panel-facto/estadisticas');
        }else{
          next();
        }
      }
    }
    else if(store.state.mfa == 1 && store.state.valid == 0){
      if (to.path === '/tokenValidation') {
        next();
      }else{
        next('/tokenValidation');
      }
    }else if(store.state.mfa == 1 && store.state.valid == 1){
      if(to.path === '/tokenValidation'){
        next('/panel-facto/estadisticas');
      }else{
        if(to.meta && to.meta.requireUserValid && !store.getters.canNavigate()){
          next('/panel-facto/estadisticas');
        }else{
          next();
        }
      }
    }

    if(to.meta && to.meta.requireUserValid && !store.getters.canNavigate()){
      next('/panel-facto/estadisticas');
    }else{
      next();
    }
  }else if (store.state.temp_token && to.path === '/tokenValidation') {
    next();
  }
  else {
    store.commit("logout");
    next(`/ingresar?return=${to.path}`);
  }
};
